import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [cargando, setCargando] = useState(false);
  const [aviso, setAviso] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await signInWithEmailAndPassword(auth, email, pass);
      navigate("/panel"); // Si entra bien, lo mandamos directo a su panel
    } catch (error) {
      alert("Error al ingresar. Verificá tu email y contraseña.");
      console.error(error);
    }
    setCargando(false);
  };

  const handleReset = async () => {
    setAviso(null);
    if (!email || !email.includes('@')) {
      setAviso({ tipo: 'error', texto: 'Escribí tu email arriba y volvé a tocar el enlace.' });
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setAviso({ tipo: 'ok', texto: `Te enviamos un correo a ${email.trim()} para restablecer la contraseña. Revisá también el spam.` });
    } catch (error) {
      // Por seguridad mostramos el mismo mensaje aunque el email no exista
      setAviso({ tipo: 'ok', texto: `Si ${email.trim()} está registrado, te enviamos un correo para restablecer la contraseña. Revisá también el spam.` });
      console.error(error);
    }
  };

  return (
    <div style={{ padding: '50px 20px', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)', width: '100%', maxWidth: '400px' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ margin: '0 0 5px 0', color: '#1a1a1a' }}>Acceso Profesional</h2>
          <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>Exclusivo para Corredores de FormoProp</p>
        </div>

        <form onSubmit={handleLogin}>
          <label style={labelStyle}>Email Profesional</label>
          <input 
            type="email" 
            placeholder="ejemplo@inmobiliaria.com" 
            onChange={e => setEmail(e.target.value)} 
            style={inputStyle} 
            required 
          />
          
          <label style={labelStyle}>Contraseña</label>
          <input 
            type="password" 
            placeholder="••••••••" 
            onChange={e => setPass(e.target.value)} 
            style={inputStyle} 
            required 
          />
          
          <button type="submit" disabled={cargando} style={btnPrimary}>
            {cargando ? "Verificando..." : "Ingresar al Sistema"}
          </button>
        </form>

        <p style={{ textAlign: 'center', margin: '16px 0 0' }}>
          <button type="button" onClick={handleReset}
            style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontSize: '13px', textDecoration: 'underline', padding: 0 }}>
            ¿Olvidaste tu contraseña?
          </button>
        </p>
        {aviso && (
          <p style={{ marginTop: '12px', padding: '10px 14px', borderRadius: '8px', fontSize: '13px',
            background: aviso.tipo === 'ok' ? '#d4edda' : '#f8d7da',
            color: aviso.tipo === 'ok' ? '#155724' : '#721c24' }}>
            {aviso.texto}
          </p>
        )}
      </div>
    </div>
  );
}

// ESTILOS
const labelStyle = { display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: 'bold', color: '#555' };
const inputStyle = { width: '100%', padding: '12px', marginBottom: '20px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box', fontFamily: 'inherit' };
const btnPrimary = { width: '100%', padding: '15px', background: '#007bff', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' };